module.exports = __webpack_public_path__ + "img/DieInselDerGlückseligen.9ee6bcb4.jpg";